import router from '@/router'

export const MixinsPageJump = {
	toPage(url, closeCurrentPage = false) {
		const obj = {
			path: url
		}
		if (closeCurrentPage) {
			router.replace(obj)
		} else {
			router.push(obj)
		}
	},
	toHome(e) {
		this.toPage('/')
	},
	toOrderList() {
		this.toPage('/order/list/list')
	},
	onProduct(id) {
		this.toPage(`/product?id=${id}`)
	},
	onCartTap(e) {
		this.toCart()
	},
	toCart(e) {
		this.toPage('/cart')
	},
	toHelp(e) {
		this.toPage('/help')
	}

}
